import { useEffect, useState } from 'react';

import { getAgentsDataConfig } from '../../config';

export const useNativeInstanceIdentity = (): string | null | undefined => {
  const config = getAgentsDataConfig();
  const useIsIdentityHydrated = config.useIsIdentityHydrated ?? (() => true);
  const getCurrentUser = config.getCurrentUser;
  const identityHydrated = useIsIdentityHydrated();
  const workspaceId = config.getWorkspaceId();
  const [userRefId, setUserRefId] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    if (!identityHydrated || !getCurrentUser) {
      setUserRefId(undefined);
      return;
    }

    setUserRefId(getCurrentUser()?.user_ref_id ?? null);
  }, [getCurrentUser, identityHydrated, workspaceId]);

  return userRefId;
};
